import { createSlice } from '@reduxjs/toolkit';
import { isEmpty, isArray, xor } from 'lib';
import { mapToFrontPlatform } from 'utils/mapper';
import { bulletinContentInitialState } from './initialState/bulletinContentInitialState';
import {
  fetchBulletin,
  fetchBulletinContents,
  sortBulletinContent,
  fetchBulletinKioskNewspapers,
} from './bulletinContent.actions';

export const bulletinContentSlice = createSlice({
  name: 'bulletinContentSlice',
  initialState: bulletinContentInitialState,
  reducers: {
    changeBulletinContentData: (state, action) => {
      const { data, platform } = action.payload;
      state.contents.data[platform] = data;
    },
    changeSortBy: (state, action) => {
      const { selected, order, platform } = action.payload;
      if (selected) {
        state.sort[platform].sortBy.selected = selected;
      }
      if (order) {
        state.sort[platform].sortBy.order = order;
      }
    },
    setSelectedBulletinContent: (state, action) => {
      const data = action.payload;

      // اگر ارایه ای از دیتا ها بود یا خالی بود جایگزین بشه
      if (isArray(data) || isEmpty(data)) {
        state.selectedContents = data;
      } else {
        // اگر یه مقدار بود و از قبل وجود داشت حذف بشه وگرنه اضافه بشه
        state.selectedContents = xor(state.selectedContents, [data]);
      }
    },
    removeBulletinContent: (state, action) => {
      const { id, platform } = action.payload;

      state.contents.data[platform] = state.contents.data?.[platform].filter(
        (item) => item.id !== id
      );
    },
    changeBulletinContentSortable: (state, action) => {
      state.sortable = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchBulletinContents.fulfilled, (state, action) => {
        state.contents.data = action.payload;
        state.contents.loading = false;
        state.contents.error = null;
      })
      .addCase(fetchBulletinContents.pending, (state) => {
        state.contents.loading = true;
        state.contents.error = null;
      })
      .addCase(fetchBulletinContents.rejected, (state, action) => {
        state.contents.loading = false;
        state.contents.error = action.payload;
      })
      .addCase(fetchBulletin.fulfilled, (state, action) => {
        const { sorts, ...rest } = action.payload;
        if (!sorts) {
          state.sort = bulletinContentInitialState.sort;
        }
        for (const platform in sorts) {
          const adaptedPlatform = mapToFrontPlatform[platform];
          state.sort[adaptedPlatform].sortBy.selected =
            sorts?.[platform]?.current_sort_type || 'defaultSort';
          state.sort[adaptedPlatform].sortBy.order =
            sorts?.[platform]?.current_sort_order || 'desc';
        }
        state.bulletin.data = rest;
        state.bulletin.loading = false;
        state.bulletin.error = null;
      })
      .addCase(fetchBulletin.pending, (state) => {
        state.bulletin.loading = true;
        state.bulletin.error = null;
      })
      .addCase(fetchBulletin.rejected, (state, action) => {
        state.bulletin.loading = false;
        state.bulletin.error = action.payload;
      })
      .addCase(sortBulletinContent.fulfilled, (state, action) => {
        const { platform, order = '', selected = '' } = action.payload;

        if (order) state.sort[platform].sortBy.order = order;
        if (selected) state.sort[platform].sortBy.selected = selected;

        state.sortRequest.loading = false;
        state.sortRequest.error = null;
      })
      .addCase(sortBulletinContent.pending, (state) => {
        state.sortRequest.loading = true;
        state.sortRequest.error = null;
      })
      .addCase(sortBulletinContent.rejected, (state, action) => {
        state.sortRequest.loading = false;
        state.sortRequest.error = action.payload;
      })
      .addCase(fetchBulletinKioskNewspapers.pending, (state) => {
        state.kioskNewspapers.loading = true;
        state.kioskNewspapers.error = null;
        state.kioskNewspapers.data = [];
      })
      .addCase(fetchBulletinKioskNewspapers.fulfilled, (state, action) => {
        state.kioskNewspapers.data = action.payload || [];
        state.kioskNewspapers.loading = false;
        state.kioskNewspapers.error = null;
      })
      .addCase(fetchBulletinKioskNewspapers.rejected, (state, action) => {
        state.kioskNewspapers.loading = false;
        state.kioskNewspapers.error = action.payload;
      });
  },
});

export const {
  changeBulletinContentData,
  setSelectedBulletinContent,
  removeBulletinContent,
  changeBulletinContentSortable,
  changeSortBy,
} = bulletinContentSlice.actions;
